// DayCal shared enums — MUST mirror the Postgres enums in
// supabase/migrations/01_extensions_enums.sql exactly (architecture.md §8.2).
// Single source of truth for both client and server.

export const USER_ROLE = Object.freeze(['USER', 'EMPLOYEE', 'SUPER_ADMIN']);
export const USER_STATUS = Object.freeze(['active', 'disabled']);

// Team Booking for Agencies (PRD §5, §8). Mirror migration 10 enums exactly.
export const AGENCY_MEMBER_ROLE = Object.freeze(['employee', 'manager']);
export const AGENCY_MEMBER_STATUS = Object.freeze(['active', 'suspended']);
export const EVENT_LOCATION = Object.freeze(['online', 'in_person', 'phone', 'custom']);
export const EVENT_STATUS = Object.freeze(['active', 'inactive']);
export const FORM_INPUT_TYPE = Object.freeze([
  'text', 'paragraph', 'number', 'email', 'phone', 'select', 'radio', 'checkbox', 'date',
]);
export const PROMO_SCOPE = Object.freeze(['host_appointment', 'platform']);
export const PROMO_DISCOUNT = Object.freeze(['percentage', 'fixed']);
export const PROMO_APPLICABLE = Object.freeze(['all', 'paid_appointments_only']);
export const BOOKING_STATUS = Object.freeze([
  'hold', 'pending', 'awaiting_payment', 'confirmed', 'completed', 'cancelled',
]);
export const PAYMENT_PROVIDER = Object.freeze(['razorpay', 'stripe']);
export const PAYMENT_STATUS = Object.freeze(['requires_action', 'succeeded', 'failed', 'refunded']);
export const CALENDAR_PROVIDER = Object.freeze(['google', 'microsoft']);

// Statuses that occupy a slot — must match the EXCLUDE constraint's WHERE clause
// in 02_schema.sql: where (status in ('hold','awaiting_payment','confirmed')).
export const SLOT_BLOCKING_STATUSES = Object.freeze(['hold', 'awaiting_payment', 'confirmed']);

export const SUPPORTED_LOCALES = Object.freeze(['en', 'bn']);
